import React from "react";
import Popupz from "../atoms/Popupz";
import Buttonz from "../atoms/Buttonz";
import PropTypes from "prop-types";

const DeleteUserPopup = ({ user, onClose, onConfirm }) => {
  return (
    <Popupz
      title="Delete User"
      text={
        <>
          Are you sure you want to delete user <strong>{user.fullName}</strong> ({user.username})?
          <br />
          This action cannot be undone.
        </>
      }
      onClose={onClose}
      popupId="delete-user"
      icon="warning"
      className="delete-confirmation"
    >
      <div className="popup-actions">
        <Buttonz
          label="Cancel"
          onClick={onClose}
          className="cancel-button"
        />
        <Buttonz
          label="Delete"
          onClick={onConfirm}
          className="delete-button danger"
          iconR="trash"
        />
      </div>
    </Popupz>
  );
};

DeleteUserPopup.propTypes = {
  user: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteUserPopup;